import { BreadcrumbItem, HeaderMenuContextType } from './main-view.state';

export class ToggleSidebar {
  public static type: string = `[MainView] ToggleSidebar`;

  constructor(public payload?: boolean) {}
}

export class SetBreadcrumbs {
  public static type: string = `[MainView] SetBreadcrumbs`;

  constructor(public payload: BreadcrumbItem[]) {}
}

export class ToggleHeader {
  public static type: string = `[MainView] ToggleHeader`;

  constructor(public payload: boolean) {}
}

export class SetHeaderMenuContext {
  public static type: string = `[MainView] SetHeaderMenuContext`;

  constructor(public payload: HeaderMenuContextType) {}
}
